module.exports = __webpack_public_path__ + "assets/img/search.1875e9b0.svg";